import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@chefami-monorepo/data-access';
import { SubscriptionStatus } from '../constants/global';

export const subscriptionGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const subscriptionStatus = auth.userInfo()?.subscription_status;
  const isAccountDeactivated =
    typeof subscriptionStatus === 'number' &&
    subscriptionStatus !== SubscriptionStatus.ACTIVE &&
    subscriptionStatus !== SubscriptionStatus.PAUSED;

  return isAccountDeactivated ? router.parseUrl('/change-subscription') : true;
};
